<div (click)="toggleCheckbox()" class="service-checkbox">
  <input [value]="isSelected" type="checkbox" [checked]="isSelected" [disabled]="disabled" />
  <div [ngClass]="{'yes': isSelected === true, 'no': isSelected === false, 'null': isSelected === null}"
    (changeEvent)="isSelected">
    <label></label>
  </div>
</div>
